<script lang="ts" generics="TValues, TValue extends unknown">
    import type { Field, Form } from '@jmvdevelop/svelte-form';
    import { fade } from 'svelte/transition';

    export let form: Form<TValues, string>;
    export let field: Field<TValues, TValue>;

    $: nbSubmits = form.stores().nbSubmits();
    $: isAlreadyBlur = form.stores().isAlreadyBlur(field);
    $: fieldErrors = form.stores().fieldErrors(field);
    $: fieldAsyncErrors = form.stores().fieldAsyncErrors(field);
</script>

{#if ($nbSubmits > 0 || $isAlreadyBlur) && $fieldErrors.length != 0}
    <div class="text-red-700 mt-1 flex flex-col gap-2" in:fade>
        {#each $fieldErrors as error}
            <p class="m-0 p-0">{error}</p>
        {/each}
    </div>
{/if}

{#if $fieldAsyncErrors.length != 0}
    <div class="text-red-700 mt-1 flex flex-col gap-2" in:fade>
        {#each $fieldAsyncErrors as error}
            <p class="m-0 p-0">{error}</p>
        {/each}
    </div>
{/if}
